export function easeOut(t) {
    return 1 - Math.pow(t - 1, 2);
}

export function easeInOutTrig(t) {
    return Math.cos(t * Math.PI + Math.PI) / 2 + 0.5;
}

export function easeOutTrig(t) {
    return Math.cos(t * Math.PI / 2 - Math.PI / 2);
}

export function easeInTrig(t) {
    return Math.cos(t * Math.PI / 2 - Math.PI) + 1;
}